























import { Component, Vue } from 'vue-property-decorator'
import Menu from '@/components/Menu.vue'
import SnackbarMsg from '@/components/snackbarMsg.vue'
import dialogConfirmAction from '@/components/dialogConfirmAction.vue'
import Login from '@/components/Login.vue'

@Component({
  components: {
    Menu,
    Login,
    dialogConfirmAction,
    SnackbarMsg
  },
})
export default class Home extends Vue {
  private name: string = 'Home App'

  private get token () {
    return this.$store.state.auth.token
  }
  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    console.log('beforeMount :: Route Params :: ', this.$route)
  }
}
